import { render } from "./ContentPlaceholdersText.vue?vue&type=template&id=3ebfaa8a&ts=true"
import script from "./ContentPlaceholdersText.vue?vue&type=script&lang=ts"
export * from "./ContentPlaceholdersText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__